import styled from 'styled-components';
import { Button as JButton } from 'junto-ui';
import { palette } from '@plataforma/components';

export const Container = styled.div`
  background-color: #180a33;
  border-radius: 4px;
  display: flex;
  height: 184px;
  justify-content: space-between;
  padding: 48px 48px 28px;
  width: 864px;
`;

export const Details = styled.div``;

export const Title = styled.h2`
  color: ${palette['color-white']};
  margin-bottom: 4px;
  font-size: 26px;
  font-weight: 600;
  font-family: Metropolis;
  font-style: normal;
  line-height: 34px;
`;

export const Text = styled.p`
  align-items: center;
  padding: 0px;
  margin-bottom: 4px;
  margin-top: 4px;
  margin-left: 4px;
  font-family: Metropolis;
  font-style: normal;
  font-size: 10px;
  line-height: 16px;
  background-color: #9000ff;
  width: 60px;
  text-align: center;
  border-radius: 4px;
`;

export const Button = styled(JButton)`
  padding: 0 42px;
  margin-top: 16px;
  background: transparent;
  border-color: white;
  box-shadow: none !important;
  font-family: Metropolis;
  font-style: normal;
  color: #ffffff;
  font-weight: 600;
  line-height: 16px;
  font-size: 12px;
  width: 146px;
  height: 32px;
`;

export const ImageWrapper = styled.div`
  height: 50px;
  position: absolute;
  right: 0;
  top: 0;
  margin-bottom: 46.93px;
`;
